<template>
    <v-card style="background-color: #efeded; height: 100%">
        <v-card-text>
            <v-row>
                <v-col><v-icon @click="dialog = true" color="primary">mdi-brush-outline</v-icon></v-col>
                <v-col>
                    <!-- Button group to toggle between Horizontal and Vertical views -->
                    <v-btn-toggle v-model="selectedChart" class="mb-4" mandatory shaped>
                        <v-btn value="chart1">{{$t('ChartOne')}}</v-btn>
                        <v-btn value="chart2">{{$t('ChartTwo')}}</v-btn>
                        <v-btn value="chart3">{{$t('ChartThree')}}</v-btn>
                        <v-btn value="chart4">{{$t('ChartFour')}}</v-btn>
                        <v-btn value="chart5">{{$t('ChartFive')}}</v-btn>
                    </v-btn-toggle>
                </v-col>
            </v-row>

            <v-dialog v-model="dialog" persistent max-width="700px">
                <v-card>
                    <div class="card-title">
                        {{ $t('ChangeColor')}}
                    </div>
                    <v-card-title></v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" sm="6">
                                <v-color-picker v-model="colorOne"
                                                mode="hexa"></v-color-picker>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-color-picker v-model="colorTwo"
                                                mode="hexa"></v-color-picker>
                            </v-col>

                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="dialog = false" text>{{$t('Close')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <!-- Horizontal layout -->
            <v-row v-if="selectedChart === 'chart1'">
                <v-col cols="auto" style="margin:auto; margin-top: 20px;">
                    <template>
                        <v-col cols="auto" style="margin:auto">
                            <template>
                                <v-row class="d-flex align-center justify-space-between" style="margin:auto">

                                    <v-col cols="auto">
                                        <v-row class="d-flex align-center">
                                            <v-col>
                                                <div :style="`background-color: white; border: 1px dashed ${colorOne};border-radius:10px;padding:10px`">
                                                    <v-row>
                                                        <v-col cols="auto" class="text-center" :style="{color: colorOne}">
                                                            <span style="font-size: 21px;">{{value[0].value}}%</span>
                                                            <br>
                                                            <span style="font-size: 21px;">{{value[0].count}}</span>
                                                        </v-col>

                                                        <v-col cols="auto">
                                                            <img src="/yes.png" style="width:70px" />
                                                        </v-col>

                                                    </v-row>
                                                </div>
                                            </v-col>
                                            <v-col cols="auto" class="text-center" :style="{color: colorTwo}">
                                                <span style="font-size: 21px;">{{value[1].value}}%</span>
                                                <br>
                                                <span style="font-size: 21px;">{{value[1].count}}</span>
                                            </v-col>

                                            <v-col cols="auto">
                                                <img src="/no.png" style="width:70px" />
                                            </v-col>

                                        </v-row>
                                    </v-col>
                                </v-row>
                            </template>
                        </v-col>
                        <!--<v-row class="d-flex align-center justify-space-between">

                    <v-col cols="auto">
                        <v-row class="d-flex align-center">
                            <v-col>
                                <div :style="`background-color: white; border: 1px dashed ${ colorOne};border-radius:10px;padding:10px`">
                                    <v-row>
                                        <v-col cols="auto" class="text-center" :style="{color: colorOne}">
                                            <span class="text-h5 font-weight-bold">{{value[0].value}}%</span>
                                            <br>
                                            <span class="text-caption">{{value[0].count}}</span>
                                        </v-col>

                                        <v-col cols="auto">
                                            <img src="/yes.png" style="width:50px" />
                                        </v-col>

                                    </v-row>
                                </div>
                            </v-col>
                            <v-col cols="auto" class="text-center" :style="{color: colorTwo}">
                                <span class="text-h5 font-weight-bold">{{value[1].value}}%</span>
                                <br>
                                <span class="text-caption">{{value[1].count}}</span>
                            </v-col>

                            <v-col cols="auto">
                                <img src="/no.png" style="width:50px" />
                            </v-col>


                        </v-row>
                    </v-col>


                </v-row>-->

                    </template>
                </v-col>
            </v-row>

            <!-- Vertical layout -->
            <v-row v-if="selectedChart === 'chart2'">
                <v-col cols="12" style="margin:auto; margin-right: 150px;">
                    <template>

                        <v-row class="pa-4 mt-2">

                            <!--<v-col cols="2"></v-col>-->
                            <!-- No Section -->
                            <v-col cols="8" :style="`border: 1px solid ${colorTwo}; border-radius: 8px; padding: 8px;margin:5px`">
                                <v-row>
                                    <v-col class="text-center"><img src="/notwo.png" style="width:50px" /><br /><span style="font-size: 21px;">{{$t('no')}}</span></v-col>
                                    <v-col style="font-size: 21px;" class="text-center"><span :style="{color: colorTwo}">{{value[0].value}}%</span><br /><span style="font-size: 21px;">{{$t('NotContactedBy')}}</span><br /><span style="font-size: 21px;">{{value[0].count}}</span></v-col>
                                </v-row>

                            </v-col>
                            <!-- Yes Section -->

                            <v-col cols="8" :style="`border: 1px solid ${colorOne}; border-radius: 8px; padding: 8px;margin:5px`">
                                <v-row>
                                    <v-col class="text-center"><img src="/yestwo.png" style="width:50px" /><br /><span style="font-size: 21px;">{{$t('yes')}}</span></v-col>
                                    <v-col style="font-size: 21px;" class="text-center"><span :style="{color: colorOne}">{{value[1].value}}%</span><br /><span style="font-size: 21px;">{{$t('ContactedBy')}}</span><br /><span style="font-size: 21px;">{{value[1].count}}</span></v-col>
                                </v-row>
                            </v-col>
                            <!--<v-col cols="2"></v-col>-->
                        </v-row>
                    </template>

                </v-col>
            </v-row>
            <v-row v-if="selectedChart === 'chart3'">
                <v-col style="margin:auto; margin-top: 20px; margin-bottom: 60px;">

                    <v-row>

                        <v-col>
                            <v-sheet color="#ffffff" rounded class="pa-4 " :style="`border: 1px dashed ${colorOne}`">
                                <table>
                                    <tr>
                                        <td><img src="/yestwo.png" style="width:30px" /></td>
                                        <td width="10"></td>
                                        <td><span style="font-size: 21px; color: rgb(0, 0, 0, 0.6);">{{$t('yes')}}</span></td>
                                        <td width="10"></td>
                                        <td><span style="font-size: 21px; color: rgb(0, 0, 0, 0.6);">{{value[0].count}}</span></td>
                                        <td width="10"></td>
                                        <td style="font-size: 21px;"><span :style="{color: colorOne }">{{value[0].value}}%</span></td>
                                    </tr>
                                </table>

                            </v-sheet>
                        </v-col>
                        <v-col>
                            <div style="position:relative;width:100%;padding-top:25px">
                                <v-progress-linear :value="value[0].value"
                                                   height="20" rounded="lg"
                                                   :color="colorOne" :background-color="colorTwo"
                                                   style="position:absolute;z-index:9;border-radius:30px"></v-progress-linear>
                                <div :style="'background-color: white; width: 20px; height: 20px; border-radius: 100%; position: absolute; right: calc('+value[0].value+'% - 10px); z-index: 999; padding: 5px'">
                                    <div style="background-color: #f4f4f4; width: 10px; height: 10px; border-radius: 100%;"></div>
                                </div>

                            </div>
                        </v-col>
                        <v-col>
                            <v-sheet color="#ffffff" rounded class="pa-4 ">
                                <table>
                                    <tr>
                                        <td><img src="/notwo.png" style="width:30px" /></td>
                                        <td width="10"></td>
                                        <td><span style="font-size: 21px; color: rgb(0, 0, 0, 0.6);">{{$t('no')}}</span></td>
                                        <td width="10"></td>
                                        <td><span style="font-size: 21px; color: rgb(0, 0, 0, 0.6);">{{value[1].count}}</span></td>
                                        <td width="10"></td>
                                        <td style="font-size: 21px;"><span :style="{color: colorTwo }">{{value[1].value}}%</span></td>
                                    </tr>
                                </table>

                            </v-sheet>
                        </v-col>
                    </v-row>


                </v-col>
            </v-row>
            <v-row v-if="selectedChart === 'chart4'">
                <v-col style="margin:auto; margin-top: 10px; margin-right: 50px;">

                    <v-row>
                        <v-col cols="2">
                            <v-sheet color="transparent" rounded class="pa-4 white--text" style="height:200px;line-height:200px"></v-sheet>
                        </v-col>
                        <v-col cols="2" style="display:flex;align-content:center;flex-wrap:wrap">
                            <div :style="`color: ${colorTwo};width:100px;font-size:21px;margin-bottom:10px;`" class="text-center">{{$t('no')}}</div>
                            <v-sheet :color="colorTwo" rounded class="pa-4 white--text text-center" style="width: 100px; font-size: 21px;">{{value[1].value}}%<br />({{value[1].count}})</v-sheet>
                        </v-col>
                        <v-col style="position: relative;" cols="3">

                            <v-progress-circular :value="100" :color="colorTwo" style="position:absolute;z-index:99;width:150px;height:150px;top:50px"></v-progress-circular>
                            <v-progress-circular :value="value[0].value" :color="colorOne" :background-color="colorTwo" style="position: absolute; z-index: 999; width: 150px; height: 150px; top: 50px"></v-progress-circular>

                        </v-col>
                        <v-col cols="2" style="display: flex; align-content: center; flex-wrap: wrap">
                            <div :style="`color: ${colorOne}; width: 100px;font-size:21px;margin-bottom:10px;`" class="text-center">{{$t('yes')}}</div>
                            <v-sheet :color="colorOne" rounded class="pa-4 white--text text-center" style="width: 100px; font-size: 21px;">{{value[0].value}}%<br />({{value[0].count}})</v-sheet>
                        </v-col>
                    </v-row>

                </v-col>

            </v-row>
            <v-row v-if="selectedChart === 'chart5'" style="margin:auto; margin-top: 70px; margin-right: 50px; margin-bottom: 80px;">
                <table style="margin:auto">
                    <tr>
                        <td valign="middle">
                            <div :style="`color: ${colorTwo};width:60px;margin-top:10px;font-size:21px;`" class="text-center">{{value[1].value}}%</div>
                            <div :style="`color: ${colorTwo};background-color:#f4f4f4;border-radius:0 30px 30px 0;width:70px;font-size:21px;`" class="text-center pa-2">{{$t('no')}}</div>
                        </td>
                        <td valign="middle">
                            <div style="position:relative;width:150px;height:120px">
                                <v-progress-circular :value="100" :color="colorTwo" style="position:absolute;z-index:99;width:150px;height:150px"></v-progress-circular>
                                <v-progress-circular :value="value[0].value" :color="colorOne" :background-color="colorTwo" style="position: absolute; z-index: 999; width: 150px; height: 150px"><img src="/innerprogress.png" style="width:50px" /></v-progress-circular>
                            </div>
                        </td>
                        <td valign="middle">
                            <div :style="`color: ${colorOne}; width: 70px;margin-top:10px;font-size:21px;`" class="text-center">{{value[0].value}}%</div>
                            <div :style="`color: ${colorOne}; background-color: #f4f4f4; border-radius: 30px 0 0px 30px; width: 70px; margin-right: 0px;font-size:21px;`" class="text-center pa-2">{{$t('yes')}}</div>
                        </td>
                    </tr>
                </table>
                <!--<v-col>

            <v-row>
                <v-col cols="1">
                    <div :style="`color: ${colorTwo};width:60px;margin-top:10px`" class="text-center  text-h5">{{value[1].value}}%</div>
                    <div :style="`color: ${colorTwo};background-color:#f4f4f4;border-radius:0 30px 30px 0;width:70px;margin-left:-150px`" class="text-center pa-2 text-h5">{{$t('no')}}</div>

                </v-col>
                <v-col style="position:relative;padding:0px;width:150px" cols="auto">
                    <div style="position:relative;width:150px">
                        <v-progress-circular :value="100" :color="colorTwo" style="position:absolute;z-index:99;width:150px;height:150px"></v-progress-circular>
                        <v-progress-circular :value="value[0].value" :color="colorOne" :background-color="colorTwo" style="position: absolute; z-index: 999; width: 150px; height: 150px"><img src="/innerprogress.png" style="width:50px" /></v-progress-circular>
                    </div>
                </v-col>
                <v-col cols="2" style="padding-right:0px;padding-left:0px">
                    <div :style="`color: ${colorOne}; width: 70px;margin-top:10px`" class="text-center text-h5">{{value[0].value}}%</div>
                    <div :style="`color: ${colorOne}; background-color: #f4f4f4; border-radius: 30px 0 0px 30px; width: 70px; margin-right: 0px`" class="text-center pa-2  text-h5">{{$t('yes')}}</div>
                </v-col>
            </v-row>
        </v-col>-->
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        props: {
            value: {
                type: Array,
                default: () => [],
            },

        },
        data() {
            return {
                selectedChart: 'chart1', // Default to horizontal view
                colorOne: '#4bc0c0',
                colorTwo: '#ff6384',
                dialog: false
            }
        },
        computed: {
        }
    }
</script>

<style scoped>
    v-btn {
        background: linear-gradient(to right, #2fbcd3, #62c6c8);
    }
</style>
